import { apiIsa, apiIsaV2, authToken } from '../../../core/services/api';
import { buildScheduleOptions, CatalogSchedule, OperationSlot } from '../scheduleOptions';
import {
  SAVE_DATE_DATA,
  GET_SCHEDULE_HOUR,
} from './schedulingConstants';

const getScheduleHourEnd = (dispatch: any, data: any) => {
  dispatch({ type: GET_SCHEDULE_HOUR, data })
};

type scheduleHourParams = {
  date: string;
  squareId: string;
  operatorId?: string;
  partnerId?: string;
  categoryId?: string;
}

const defaultHeaders = {
  'Content-Type': 'application/json',
  'Authorization': `${authToken}`,
};

export const getScheduleHour = (params: scheduleHourParams, callback: any) => {
  return (dispatch: any) => {
    Promise.all([
      apiIsaV2.get(`operations/slot-times`, {
        params: {
          'filter[date]': params.date,
          'filter[operation.id]': params.squareId,
          ...(params.operatorId && { 'filter[operator.id]': params.operatorId }),
          ...(params.partnerId && { 'filter[partner.id]': params.partnerId }),
          ...(params.categoryId && { 'filter[category.id]': params.categoryId })
        },
        headers: defaultHeaders
      }),
      apiIsa.get(`/schedule?includePeriods=true`, {
        headers: defaultHeaders
      })
    ])
      .then(([slotTimesResponse, catalogResponse]) => {
        const slotsData: OperationSlot[] = slotTimesResponse?.data?.data ?? []
        const catalog: CatalogSchedule[] = catalogResponse?.data ?? []

        const slots = buildScheduleOptions(slotsData, catalog)

        getScheduleHourEnd(dispatch, slots)
        callback(dispatch, slots)
      })
      .catch((err) => {
        callback(err.message);
      });
  };
};

export const saveDateData = (data: any) => {
  return (dispatch: any) => {
    dispatch({ type: SAVE_DATE_DATA, data })
  }
};
